export default {
  name: 'DepositAmountOverview',
  props: {
    amount: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    infoAmount() {
      const number = Number(this.amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return `$${number}`;
    },
  },
};
